import Component from '../../Component';

class TrevorForm extends Component<HTMLElement> {
	static selector = '.trevor-form';

	static children = {
		form: '.trevor-form__form',
		submit: '.trevor-form__submit',
	};

	fieldBlocks: Record<string, HTMLElement | HTMLElement[]> = {};

	afterInit() {
		this.parseFieldBlocks();
		this.bindForm();
	}

	bindForm() {
		(this.children?.form as HTMLElement).addEventListener(
			'submit',
			this.onSubmit.bind(this)
		);

		(this.children?.form as HTMLElement).addEventListener(
			'change',
			this.onChange.bind(this)
		);

		(this.children?.form as HTMLElement).addEventListener(
			'reset',
			this.onChange.bind(this)
		);
	}

	extractFormData() {
		const formData: Record<
			string,
			string | number | boolean | Array<string | number>
		> = {};

		const rawFormData = new FormData(
			this.children?.form as HTMLFormElement & HTMLElement[]
		);

		const keys = Array.from(rawFormData.keys());
		const entries = Array.from(rawFormData.entries());

		entries.forEach(([key, value]) => {
			// Append data key if not yet parsed
			if (!(key in formData)) {
				formData[key] =
					// Determine if array field acc. to multiple instances (e.g., checkbox)
					keys.indexOf(key) !== keys.lastIndexOf(key) ? [] : '';
			}

			if (Array.isArray(formData[key])) {
				(formData[key] as (string | number)[]).push(
					value as string | number
				);
			} else {
				formData[key] = value as string | number | boolean;
			}
		});

		return formData;
	}

	parseFieldBlocks() {
		const fieldBlocks = Array.from(
			document.querySelectorAll('.trevor-form__field-block[data-name]')
		) as HTMLElement[];

		fieldBlocks.forEach((fieldBlock) => {
			const name = fieldBlock.getAttribute('data-name') as string;

			if (!(name in this.fieldBlocks)) {
				this.fieldBlocks[name] = fieldBlock;
			} else {
				// If fieldBlock name is already set, convert into array
				if (!Array.isArray(this.fieldBlocks[name])) {
					this.fieldBlocks[name] = [
						this.fieldBlocks[name] as HTMLElement,
					];
				}

				(this.fieldBlocks[name] as HTMLElement[]).push(fieldBlock);
			}
		});
	}

	setFieldError(field: string, message: string | false) {
		if (field in this.fieldBlocks) {
			if (!Array.isArray(this.fieldBlocks[field])) {
				const errorElement = (
					this.fieldBlocks[field] as HTMLElement
				).querySelector('.trevor-form__error') as HTMLElement;

				errorElement.textContent = message ? message : '';
			}
		}
	}

	setBusy(isBusy?: boolean) {
		this.element.classList.toggle('trevor-form--busy', isBusy);
	}

	onChange() {
		setTimeout(() => {
			const formData = this.extractFormData();

			const isFilled = Object.values(formData).some((value) =>
				Boolean(Array.isArray(value) ? value.length : value)
			);

			if (isFilled) {
				(this.children?.submit as HTMLElement).removeAttribute(
					'disabled'
				);
			} else {
				(this.children?.submit as HTMLElement).setAttribute(
					'disabled',
					'disabled'
				);
			}
		}, 100);
	}

	onSubmit(event: SubmitEvent) {
		event.preventDefault();

		const formData = this.extractFormData();

		// Sanitize phone number
		formData.phone = (formData.phone as string).replace(/[^0-9]/g, '');

		// Emit event attaching formData, for external consumption
		(this.children?.form as HTMLFormElement).dispatchEvent(
			new CustomEvent('trevorform-submit', {
				detail: {
					data: formData,
					component: this,
				},
			})
		);
	}
}

TrevorForm.init();
